import { Sparkles } from "lucide-react";

export const BotAvatar = () => {
  return (
    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#D14081]">
      <Sparkles className="h-4 w-4 text-white" />
    </div>
  );
};

